import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {ApiFactoryService} from '../shared/services/api-factory.service';
import {AbstractBffApi, KeystringValueInterface} from '../models/sharedinterface';
import {ShareddataService} from '../shared/services/shareddata.service';
import {GlobalsService} from '../shared/services/globals.service';

@Injectable({
  providedIn: 'root'
})
export class RoutehomeguardGuard implements CanActivate {

  isloggedin: boolean;

  bffapi: AbstractBffApi;

  currentlanguage: KeystringValueInterface;

  constructor(
    private authservice: AuthenticationService,
    private router: Router,
    private apifactory: ApiFactoryService,
    private shareddata: ShareddataService,
    private globalsservice: GlobalsService
  ) {
    this.bffapi = this.apifactory.createBffApi();
    this.authservice.isloggedin$.subscribe((data) => {
      this.isloggedin = data;
    });
    this.shareddata.currentlanguage$.subscribe((data) => {
      this.currentlanguage = data;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // We always have access to this page
    // But always check remote and set the isloggin shared data accordingly

    this.authservice.checkLocalSession();

    if (this.isloggedin) {
      // Recheck remote session
      const query = this.bffapi.checkuser();
      query.subscribe((response) => {
          const roles = response.results.roles;
          this.shareddata.setUserroles(roles);

          this.authservice.setLoggedin(true);
        },
        error => {
          this.authservice.setLoggedin(false);

        });
    } else {
      this.authservice.setLoggedin(false);

    }// if

    // We always have access to this page
    return true;
  }

}
